import axios from 'axios';
import { config } from './config';
import { getAccessToken, getRefreshToken, saveTokens } from '@/utils/tokenStorage';
import { refreshAccessToken } from './refreshService';
import { appEvents, EXPIRED_SESSION_EVENT } from '@/utils/appEvents';

const apiClient = axios.create({
  baseURL: config.API_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (request) => {
  const token = await getAccessToken();
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = await getRefreshToken();
        const result = await refreshAccessToken(refreshToken!);
        if (!result) return;
        await saveTokens(result.accessToken, result.refreshToken);

        originalRequest.headers.Authorization = `Bearer ${result.accessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        appEvents.dispatchEvent(new Event(EXPIRED_SESSION_EVENT));
        throw refreshError;
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
